import { render, staticRenderFns } from "./VideoClip.vue?vue&type=template&id=7ea80d1c&scoped=true"
import script from "./VideoClip.vue?vue&type=script&lang=js"
export * from "./VideoClip.vue?vue&type=script&lang=js"
import style0 from "./VideoClip.vue?vue&type=style&index=0&id=7ea80d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea80d1c",
  null
  
)

export default component.exports